import clsx from 'clsx';
import React, { FC, forwardRef, HTMLProps } from 'react';
import { refHandler } from '../../utils/ref-handler/ref-handler.ts';
import { InputWrapper, InputWrapperProps } from '../input-wrapper';
import classes from './text-input.module.scss';

export type TextInputProps = Omit<InputWrapperProps<string>, 'ref'> & Omit<
  HTMLProps<HTMLDivElement>,
  'ref' | 'label' | 'name' | 'disabled' | 'value' | 'prefix' | 'suffix' | 'onChange'
>;

export const TextInput: FC<TextInputProps> = forwardRef<HTMLDivElement, TextInputProps>(
  (
    {
      ...props
    },
    ref
  ) => {
    return (
      <InputWrapper
        {...props}
        onChange={e => props.onChange?.(e)}
        className={clsx(props.className, classes.root, 'text-input-component')}
        rootRef={refHandler(ref)}
      >
        <input className={clsx(classes.input, props.classes?.input)} />
      </InputWrapper>
    );
  }
);
